export default __webpack_public_path__ + "static/media/DSC_7346.55115b5a.jpg";